export enum HistogeneticsCategory {
    DonorHighResTT = 0,
    RecipientHighResTT = 1,
    FVHighResTT = 2,
    CryoReceived = 3,
    CryoShipped = 4,
    AboUploads = 5
}